'use strict';

const tracking = require('../../tracking/boarding_options');

module.exports = {
    selectors: {
        boardingOptionsMainContainer: '.boarding_options_main_container',
        openButton: '.boarding_options_open_button',
        termsTooltipHint: '.terms_tooltip_hint',
    },
    events: {
        'tap @openButton': 'onTapOpenButton',
        'tap @nagBtnOption': 'onNagBtnOption',
        'tap @lightboxClose': 'closeNag',
    },

    loadView() {
        if (Odigeo.AB.isCssVariationMobile && !Odigeo.AB.isCabinBagsWidgetOF2Mobile) {
            this.trackOnPaxLoad();
            tracking.trackBoardingOptionAllSections(this.model.getTrackingData());
        }

        this.render();
    },

    render() {
        this.renderMainTemplate();
    },

    renderMainTemplate() {
        const nonCssVariationMobileClasses = Odigeo.AB.isCobaltBoxVariant ? 'prisma-elevation-1' : 'odf-box-primary';
        const additionalClasses = Odigeo.AB.isCssVariationMobile ? '' : nonCssVariationMobileClasses;
        this.setTemplate(this.$el, 'boardingOptionWrapper', {
            additionalClasses,
        });
    },

    renderBoardingOptionContainerTemplate() {
        const data = this.getTemplateData();
        this.setTemplate(
            this.$cachedSelectors.boardingOptionsMainContainer,
            Odigeo.AB.isCssVariationMobile ? 'boardingOptionsWidgetCobaltVariation' : 'boardingOptionsWidget',
            data
        );
        this.loadWidgetHints();
    },

    renderPopupTemplate(params) {
        const data = Odigeo._.extend(this.getTemplateData(), params || {});
        this.setTemplate(
            this.$cachedSelectors.boardingOptionsPopupContainer,
            Odigeo.AB.isCssVariationMobile ? 'boardingOptionsPopupCobaltVariation' : 'boardingOptionsPopup',
            data
        );
        this.loadPopupHints();
    },

    getCommonTemplateData() {
        const carrier = this.model.getCarrier();
        const type = this.model.getSelectedType().toLowerCase();
        const selectedTypeNew = type === 'bo_sb' ? 'small_bag' : 'cabin_bag';
        const carrierProperties = Odigeo.JCMS.cabinBagsCarrierProperties[carrier] || {};

        return Odigeo._.extend(this.model.getData(), {
            carrierLower: carrier.toLowerCase(),
            icon: this.getSelectedIcon(),
            confirmationIcon: this.getSelectedConfirmationIcon(),
            keys: this.keys,
            carrierProperties,
            selectedType: type,
            selectedTypeNew,
            isDefaultOptionSelected: this.model.isDefaultOptionSelected(),
            highlightedTypeIndex: this.model.getHighlightedTypeIndex(),
            keyIndex: `${carrier.toLowerCase()}_${type}`,
            debugInfo: this.getDebugInfo(),
            primeInfo: this.model.getPrimeInfo(),
            selectedCabinBagOptionPriceInfo: this.getSelectedCabinBagOptionPriceInfo(),
            isNegativePrimeMarkupPriceVisible: this.model.isNegativePrimeMarkupPriceVisible(),
        });
    },

    getSelectedIcon() {
        return Odigeo._.get(this.model.findByType(this.model.getSelectedType()), 'icon');
    },

    getSelectedConfirmationIcon() {
        return Odigeo._.get(this.model.findByType(this.model.getSelectedType()), 'confirmationIcon');
    },

    getHintTrackingData() {
        const data = this.getTrackingData();
        const maxdsc = data.isPrimeAB ? ['_maxdsc', data.maxdsc].join('') : '';
        return {
            type: 'trackEvent',
            data: {
                action: 'cabin_bag_widget',
                label: [
                    'cabin_bag_info-',
                    tracking.getSelectedTypeTrackingConstant({
                        selectedType: data.selectedType,
                    }),
                    '_legs:',
                    data.totalNumber,
                    '-',
                    data.carrierNumber,
                    maxdsc,
                    '_carrier:',
                    this.model.getCarrier(),
                ].join(''),
            },
        };
    },

    getPopupHintTrackingData() {
        const data = this.getTrackingData();
        const source = tracking.getPopupMode() ? 'popup' : 'nag';
        const maxdsc = data.isPrimeAB ? ['_maxdsc', data.maxdsc].join('') : '';

        return {
            type: 'trackEvent',
            data: {
                action: 'cabin_bag_' + source,
                label: [
                    'cabin_bag_',
                    source,
                    '_info-',
                    tracking.getSelectedTypeTrackingConstant({
                        selectedType: data.selectedType,
                    }),
                    '-none_legs:',
                    data.totalNumber,
                    '-',
                    data.carrierNumber,
                    maxdsc,
                    '_carrier:',
                    this.model.getCarrier(),
                ].join(''),
            },
        };
    },

    getTrackingData() {
        return Odigeo._.get(this.model.getData(), 'trackingData', {});
    },

    trackContinueToPayment() {
        this.trackContinue('pax');
    },

    trackOnPaxLoad() {
        tracking.trackOnPaxLoad();
    },

    trackContinueToConfirmation() {
        this.trackContinue('pay');
    },

    trackContinue(page) {
        tracking.trackingBoardingOptionsContinue(
            Odigeo._.extend(
                this.getTrackingData(),
                {
                    page: page + this.getProductPageIdentifier(),
                },
                this
            )
        );
    },

    getProductPageIdentifier() {
        return Odigeo.Utils.isRequestApp('dp') ? 'dp' : 'fl';
    },

    getDebugInfo() {
        const collection = this.model.get('collection');
        let options = [];
        Odigeo._.forEach(collection, (option) => {
            if (!Odigeo._.isNull(option.debugInfo)) {
                options.push(option.debugInfo);
            }
        });
        return options;
    },

    getDesktopAB() {
        return Odigeo._.get(Odigeo, 'AB.getBoardingOptionsWidget', 1);
    },

    getMobileAB() {
        return Odigeo._.get(Odigeo, 'AB.boardingOptionsMobile', 1);
    },

    isABEnabled() {
        return Odigeo.SessionScope.flow === 'mobile' ? this.getMobileAB() : Odigeo._.includes([2, 3], this.getDesktopAB());
    },

    onNagBtnOptionOF2(type) {
        tracking.setPopupMode('nag');
        this.model.selectType(type, true);
        this.renderBoardingOptionContainerTemplate();
        this.widget.proceedToPayment();
    },
    getSelectedCabinBagOptionPriceInfo() {
        const selectedCabinBagOption = this.model.getAvailableOptions()?.find((option) => option.type === 'BO_PB');
        if (selectedCabinBagOption) {
            return {
                price: selectedCabinBagOption?.totalPrice,
                primePrice: selectedCabinBagOption?.totalPrimePrice,
            };
        }
        return {};
    },
};
